





























import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import Cgv from './components/Modal/CGV.vue'
import Maintenance from './components/auth/Maintenance.vue'
import ErrorHandler from '@/components/reusable-components/layout/error/ErrorHandler.vue'
import { Socket } from 'socket.io-client'
import { isMobile } from 'mobile-device-detect'
import visibility from 'vue-visibility-change'
import PrivateLayout from '@/layouts/PrivateLayout.vue'
import NoLayout from './layouts/NoLayout.vue'
import FeedbackModal from '@/components/feedback/FeedbackModal.vue'
import { Member } from '@/types/Member.type'
import ModalDeviceError from '@/components/Modal/ModalDeviceError.vue'
import ModalCharterLeClub from '@/components/Modal/ModalCharterLeClub.vue'
import DialogToast from './components/UI/dialogs/DialogToast.vue'
import UpgradeModal from '@/components/upgrade/modal/UpgradeModal.vue'

const user = namespace('user')
const app = namespace('app')

@Component({
    components: {
        ModalCharterLeClub,
        ModalDeviceError,
        FeedbackModal,
        ErrorHandler,
        Cgv,
        Maintenance,
        DialogToast,
        UpgradeModal,
    },
})
export default class App extends Vue {
    @user.Getter isConnected!: Function
    @user.State socket!: Socket | null
    @user.State readonly me!: Member
    @user.Getter isSwitchedToMember!: boolean
    @user.Getter isLostMember!: boolean
    @app.State readonly maintenance!: boolean
    // socket: SocketIOClient.Socket | null = null
    NoLayout: typeof NoLayout = NoLayout

    async created() {
        await this.$store.dispatch('app/getConfiguration')
        this.connectSocket()
        if (isMobile) {
            this.detectVisibilityChange()
        }
    }

    get layoutComponent() {
        if (this.$route.name === null) return NoLayout

        return this.$store.state.app.layoutComponent || this.$route.meta.layout || PrivateLayout
    }

    get layoutProps() {
        return {
            ...(this.$route.meta.layoutProps || {}),
            ...(this.$store.state.app.layoutProps || {}),
        }
    }

    /**
     * On ajoute cette sécurité car on redirige vers la home page après le login (qui n'est pas dans la SPA) et on risque de faire un appel pour afficher le feedback juste avant
     * la redirection. Ce qui fait qu'en arrivant sur la Home, le feedback ne s'affichera pas.
     */
    get isOnAuthPage(): boolean {
        return window.location.href.includes('/login') || window.location.href.includes('/register')
    }

    mounted() {
        const appEl = document.querySelector('#app')

        document.body.classList.add('loaded')

        if (appEl) {
            const DOMObserver = new MutationObserver(() => {
                // @ts-ignore
                window.TranslationBundleEditInPlace?.(
                    window.Routing.generate('translation_edit_in_place_update', ['app', 'fr'])
                )
            })

            DOMObserver.observe(appEl, { childList: true, subtree: true })
        }
    }

    detectVisibilityChange() {
        visibility.change((evt, hidden) => {
            if (hidden) this.socket?.disconnect()
            else this.connectSocket()
        })
    }

    connectSocket() {
        if (this.isConnected) {
            this.$store.dispatch('user/connectSocket', {
                url: process.env.VUE_APP_NETWORKING_QUEUE_URL,
            })
        }
    }
}
